export default __webpack_public_path__ + "static/groepspraktijk-de-brug-f7edc1d39d47157dc54fc91e906b825e.png";